<template>
<div class="wlx-enterprise-banner-wrappers">
    <div class="enterprise-banner-con" :style="{backgroundImage: 'url(' + bannerImg + ')'}"></div>
    <div class="pc-table-data-con table-data-con clearfix">
        <div class="search-job-con">
            <el-input placeholder="请输入岗位名称/企业名称/工作地点" v-model="jogName" @blur="searchJobList">
                <el-button slot="append" icon="el-icon-search" @click="searchJobList"></el-button>
            </el-input>
        </div>
        <div class="clearfix">
            <div class="fl job-list-con">
                <div v-if="list.length > 0">
                    <ul>
                        <li v-for="(item, index) in list" :key="index" class="job-li-item" @click="toJobDetail(item.id)">
                            <p class="clearfix p-job-company">
                                <span class="fl sp-job-name">{{ item.jobsName }}</span>
                                <span class="fr sp-company-name">{{ item.companyName }}</span>
                            </p>
                            <div class="clearfix job-need-con">
                                <div class="fl job-need-intro">
                                    <span class="sp-job-label">{{ item.needProvince }}</span>
                                    <span class="sp-job-label">|</span>
                                    <span class="sp-job-label">{{ item.elevel }}人</span>
                                    <span class="sp-job-label">|</span>
                                    <span class="sp-job-label">{{ item.needNumber }}</span>
                                </div>
                                <div class="fr need-stu-major" v-html="item.majorRequirements"></div>
                            </div>
                            <p class="clearfix p-industry-con">
                                <span class="fl" style="color: #05243D;">薪资：{{item.SalaryInfo}}</span>
                                <span class="fr">{{ item.industryField }}</span>
                            </p>
                            <p class="clearfix p-industry-con">
                                <span class="fl" style="color: #4d4d4d;font-size:14px;">发布日期：{{item.PulishTime}}</span>
                            </p>
                        </li>
                    </ul>
                    <div>
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                        </el-pagination>
                    </div>
                </div>
                <div style="margin-top:100px;" v-else>
                    <data-none></data-none>
                </div>
            </div>
            <div class="fr recommend-job-con">
                <div class="re-job-title">热门岗位</div>
                <ul>
                    <li v-for="(item, index) in hotJobList" :key="index" class="re-job-item" @click="toJobDetail(item.id)">
                        <div class="re-job-name clearfix">{{ item.JobsName }}</div>
                        <div class="re-job-name clearfix">薪资：{{ item.SalaryInfo }}</div>
                        <div class="clearfix re-job-province">
                            <span class="fl re-company-name">{{ item.CompanyName }}</span>
                            <span class="fr re-need-province">{{ item.NeedProvince }}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="ph-table-data-con clearfix">
        <van-tabs v-model="active">
            <van-tab title="岗位列表">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
                        <div class="ph-search-job-con">
                            <el-input placeholder="请输入岗位名称/企业名称" v-model="jogName" @blur="searchJobList">
                                <el-button slot="append" icon="el-icon-search" @click="searchJobList"></el-button>
                            </el-input>
                        </div>
                        <div class="ph-job-list-con">
                            <div v-for="item in list" :key="item.id" class="ph-job-item-con" @click="toJobDetail(item.id)">
                                <p class="clearfix p-job-name">
                                    {{ item.jobsName }}
                                </p>
                                <p class="p-company-name">
                                    {{ item.companyName }}
                                </p>
                                <div class="clearfix job-need-con">
                                    <div class="fl job-need-intro">
                                        <span class="sp-job-label">{{ item.needProvince }}</span>
                                        <span class="sp-job-label">|</span>
                                        <span class="sp-job-label">{{ item.elevel }}人</span>
                                        <span class="sp-job-label">|</span>
                                        <span class="sp-job-label">{{ item.needNumber }}</span>
                                    </div>
                                </div>
                                <p class="clearfix p-industry-con">
                                    <span class="fl" style="color: #05243D;">薪资：{{item.SalaryInfo}}</span>
                                    <span class="fr">{{ item.industryField }}</span>
                                </p>
                                <p class="clearfix p-industry-con">
                                    <span class="fl" style="color: #4d4d4d;font-size:14px;">发布日期：{{item.PulishTime}}</span>
                                </p>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="热门岗位">

                <div class="ph-search-job-con">
                    <el-input placeholder="请输入热门岗位名称/企业名称" v-model="hotjobName" @blur="searchHotJobList">
                        <el-button slot="append" icon="el-icon-search" @click="searchHotJobList"></el-button>
                    </el-input>
                </div>
                <div class="ph-job-list-con">
                    <div v-for="item in hotJobList" :key="item.id" class="ph-job-item-con" @click="toJobDetail(item.id)">
                        <p class="clearfix p-job-name">
                            {{ item.JobsName }}
                        </p>
                        <p class="p-company-name">
                            {{ item.CompanyName }}
                        </p>
                        <div class="clearfix job-need-con">
                            <div class="fl job-need-intro">
                                <span class="sp-job-label">{{ item.NeedProvince }}</span>
                                <span class="sp-job-label">|</span>
                                <span class="sp-job-label">{{ item.Elevel }}人</span>
                                <span class="sp-job-label">|</span>
                                <span class="sp-job-label">{{ item.NeedNumber }}</span>
                            </div>
                        </div>
                        <p class="clearfix p-industry-con">
                            <span class="fl" style="color: #05243D;">薪资：{{item.SalaryInfo}}</span>
                            <!-- <span class="fr">{{ item.industryField }}</span> -->
                        </p>
                        <p class="clearfix p-industry-con">
                            <span class="fl" style="color: #4d4d4d;font-size:14px;">发布日期：{{item.PulishTime}}</span>
                        </p>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            list: [],
            addNewNoticeVisible: false,
            editNoticeVisible: false,
            viewNoticeVisible: false,
            /* -----------添加/修改弹框参数------------ */
            sTitle: '',
            industryField: '',
            elevel: 0,
            companyName: '',
            jobsName: '',
            phone: '',
            needProvince: '',
            needNumber: '',
            abilityRequirements: '',
            majorRequirements: '',
            note: '',
            /* --------------------------------------- */
            id: '',
            ids: [],
            cName: '',
            options: [{
                    label: '高职',
                    value: 1,
                },
                {
                    label: '中职',
                    value: 2,
                },
            ],
            value: '',
            needJobsId: '',
            urlAliyunOSS: '/api/design/osssign/getsign',
            bannerImg: require('assets/images/enterprise-banner-img.png'),
            hotJobList: [],
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            jogName: '',
            active: 0,
            refreshing: false,
            loading: false,
            finished: false,
            hotjobName:''
        };
    },
    created() {
        this.getJobsList();
        this.getHotJobList();
    },
    methods: {
        onRefresh() {
            this.pageSize = 10;
            this.getJobsList();
        },
        searchHotJobList() {
            this.getHotJobList();
        },
        onLoad() {
            this.pageSize += 10;
            this.getJobsList();
        },
        searchJobList() {
            this.getJobsList();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getJobsList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getJobsList();
        },
        toHome() {
            this.$router.push({
                name: 'xHome'
            });
        },
        getJobsList() {
            this.$http
                .post('/api/XOrg/JobsNeedAllList/getJobsList', {
                    page: this.pageIndex,
                    pageSize: this.pageSize,
                    cName: this.jogName,
                    ETyoe: this.value,
                })
                .then(rst => {
                    if (rst.code > 0) {
                        this.list = rst.list;
                        this.totalCount = rst.pagination.totalCount;
                        this.loading = false;
                        this.refreshing = false;
                        if (this.list.length == this.totalCount) {
                            this.finished = true;
                        }
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        getHotJobList() {
            this.$http
                .post('/api/XOrg/JobsNeedAllList/getHotJobList', {
                    cName: this.hotjobName
                }).then(res => {
                    if (res.code > 0) {
                        this.hotJobList = res.hotList;
                        this.refreshingHot = false;
                    }
                });
        },
        toJobDetail(id) {
            this.$router.push({
                name: 'jobDetail',
                params: {
                    jobId: id,
                },
            });
        },
        //返回
        goBack() {
            this.$router.push({
                name: 'xHome',
            });
        },
        handleSelectionChange(val) {
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.id);
            });
        },
        search() {
            this.getJobsList(1);
        },
    },
};
</script>

<style lang="scss">
@import '~theme/mixin/mixins.scss';

.wlx-enterprise-banner-wrappers {
    padding-bottom: 30px;
    min-height: 640px;
    background: #f5f5f5;

    .nav-main-con {
        height: 40px;
        line-height: 40px;
        color: #333333;
        font-size: 14px;

        .wl-icon-zhuye1 {
            margin-right: 8px;
            color: rgb(238, 70, 80);
        }

        .sp-nav-line {
            margin: 0 6px;
        }

        .sp-nav-link {
            cursor: pointer;
        }
    }

    .search-job-con {
        margin: 40px auto 50px;
        width: 820px;

        .el-input__inner {
            height: 56px;
            line-height: 56px;
            font-size: 18px;
            border-radius: 28px 0 0 28px;
        }

        .el-input__inner:focus {
            border-color: #05243D;
        }

        .el-input-group__append {
            border-radius: 0 28px 28px 0;
            background: #05243D;
            color: #fff;
            border-color: #05243D;
            font-size: 22px;
        }
    }

    .u-school-manager-headss {
        text-align: right;
    }

    .news-page-con {
        padding: 20px 0;
        text-align: center;
    }

    .enterprise-banner-con {
        height: 240px;
        background-size: cover;
        background-position: center top;
        background-repeat: no-repeat;
    }

    .table-data-con {
        margin: 0 auto;
        width: 1200px;

        .job-list-con {
            width: 860px;
        }

        .recommend-job-con {
            padding: 20px;
            width: 310px;
            box-sizing: border-box;
            background: #ffffff;
            border-radius: 4px;

            .re-job-title {
                padding-left: 5px;
                color: #333333;
                font-size: 18px;
                line-height: 1;
                border-left: 3px solid #05243D;
            }

            .re-job-item {
                margin-top: 25px;
                cursor: pointer;
            }

            .re-job-name {
                margin-bottom: 10px;
                color: #05243D;
                font-size: 16px;
                @include hidden-word();
            }

            .re-job-province {
                color: #666666;
                font-size: 14px;
                @include hidden-word();
            }

            .re-company-name {
                @include hidden-word();
            }

            .re-need-province {
                @include hidden-word();
            }
        }

        .job-li-item {
            margin-bottom: 30px;
            padding: 21px 26px 0 26px;
            height: 177px;
            background: #ffffff;
            border-radius: 4px;
            border-left: 4px solid #05243D;
            box-sizing: border-box;
            transition: all 0.3s;
            cursor: pointer;
        }

        .job-li-item:hover {
            transform: translate3d(0, -2px, 0);
            box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.13);
        }
    }

    .p-job-company {
        margin-bottom: 16px;

        .sp-job-name {
            color: #05243D;
            font-size: 20px;
            font-weight: 400;
        }

        .sp-company-name {
            color: #000;
            font-size: 16px;
            font-weight: 400;
        }
    }

    .job-need-intro {
        color: #4d4d4d;
    }

    .job-need-con {
        .sp-job-label {
            margin-right: 10px;
        }

        .need-stu-major {

            p,
            div {
                color: #4d4d4d;
            }
        }
    }

    .p-industry-con {
        margin-top: 15px;
        color: #999999;
        font-size: 16px;
    }

    .ph-table-data-con {
        display: none;
    }
}

@media only screen and (max-width:1024px) {
    .wlx-enterprise-banner-wrappers {
        .enterprise-banner-con {
            height: 81px;
        }

        .pc-table-data-con {
            display: none;
        }

        .ph-table-data-con {
            display: block;
        }

        .ph-job-list-con {
            padding: 0 20px;
        }

        .ph-job-item-con {
            margin-top: 15px;
            padding: 10px;
            color: #333333;
            background: #fff;
            font-size: 18px;
            line-height: 1;
            border-left: 2px solid #05243D;
            border-radius: 4px;

            .p-job-name {
                color: #05243D;
                font-size: 16px;
                font-weight: 500;
            }

            .job-need-con {
                font-size: 14px;
            }

            .p-company-name {
                margin: 10px 0;
                font-size: 14px;
            }

            .p-industry-con {
                margin-top: 10px;
                font-size: 14px;
            }
        }

        .ph-search-job-con {
            margin: 0 40px;
            padding-top: 20px;

            .el-input__inner {
                height: 38px;
                line-height: 38px;
                font-size: 14px;
                border-radius: 16px 0 0 16px;
            }

            .el-input__inner:focus {
                border-color: #05243D;
            }

            .el-input-group__append {
                border-radius: 0 16px 16px 0;
                background: #05243D;
                color: #fff;
                border-color: #05243D;
                font-size: 14px;
            }
        }
    }
}
</style>
